/* Recompute only visual placement; no app, commerce or audio state is touched. */
(() => {
  const scope = document.body;
  if (!scope.classList.contains('kiive-pdp-corrections') || scope.dataset.pdpCorrectionsBound) return;
  scope.dataset.pdpCorrectionsBound = 'true';
  const main = document.getElementById('main') || document.getElementById('MainContent');
  if (!main) return;
  let scheduled = false;
  function update() {
    scheduled = false;
    let previous = 'right';
    for (const panel of main.querySelectorAll('[data-media-mode="side-by-side"]')) {
      const requested = panel.dataset.mediaPosition;
      const resolved = requested === 'left' || requested === 'right' || requested === 'center'
        ? requested : previous === 'left' ? 'right' : 'left';
      panel.dataset.resolvedPosition = resolved;
      if (resolved !== 'center') previous = resolved;
      const art = panel.querySelector('.ki-bundle-member__art');
      const img = art && art.querySelector('img');
      if (img) {
        const width = img.naturalWidth || Number(img.getAttribute('width'));
        const height = img.naturalHeight || Number(img.getAttribute('height'));
        art.dataset.artOrientation = width > height ? 'wide' : 'portrait';
      }
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  update();
  for (const name of ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:unload', 'shopify:block:select']) {
    document.addEventListener(name, schedule);
  }
  main.addEventListener('load', event => {
    if (event.target.tagName === 'IMG' && event.target.closest('.ki-bundle-member__art')) schedule();
  }, true);
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
})();
